<div
  class="progress"
  [ngStyle]="{ width: (progress / total) * 100 + '%' }"
></div>
